<cmps-wait-status *ngIf="state?.hasPendingData"></cmps-wait-status>
<div
    class="body"
    *ngIf="!state?.hasPendingData"
>
    <div class="cmps-cdk-mt-0dot5">
        <form class="position-relative">
            <input
                name="keyWord"
                class="w-100 search-box"
                [placeholder]="_i18n._11159_ENTER_A_NAME_TO_SEARCH | translate"
                [ngModel]="state?.keyword ?? ''"
                (ngModelChange)="_onKeywordFilterChange($event)"
            />
            <cmps-icon
                svgIcon="magnify"
                class="magnify"
            ></cmps-icon>
        </form>
    </div>
    <div class="cmps-cdk-overflow-x-hidden cmps-cdk-my-0dot5">
        <cmps-accordion
            class="cmps-coaching-detail-pillar-two--accordion"
            [multi]="false"
        >
            <ng-container
                *ngFor="let cat of state?.filteredChatSummary; let i = index"
            >
                <cmps-accordion-item
                    [isOpen]="cat.isOpen"
                    (isOpenChange)="_onCategoryOpenChange(cat, $event)"
                >
                    <cmps-accordion-header class="item">
                        <div
                            class="row menu"
                            (click)="
                                _onChatClick(
                                    cat.hasMultipleConversations,
                                    cat.subCategories[0]
                                )
                            "
                        >
                            <div class="col-xs-1 avatar">
                                <!-- TODO add if for avatar -->
                                <cmps-icon
                                    svgIcon="account-circle"
                                    class="avatar-placeholder ml-2"
                                ></cmps-icon>
                            </div>
                            <div class="col menu-label">
                                <span class="correspondent">{{
                                    cat.name
                                }}</span>
                                <div *ngIf="cat.hasMultipleConversations">
                                    <span>{{
                                        _i18n._11164_CONVERSATIONS_ACTIVE
                                            | translate
                                    }}</span>
                                </div>
                                <div
                                    class="label"
                                    *ngIf="!cat.hasMultipleConversations"
                                >
                                    <span>{{ cat.label }}</span>
                                </div>
                            </div>
                            <div class="col-xs-1 menu-timestamp">
                                <div *ngIf="cat.isToday">
                                    <span>{{
                                        cat.lastUpdatedOn | cmpsDate: 'h:mm a'
                                    }}</span>
                                </div>
                                <div *ngIf="cat.isYesterday">
                                    <span>{{
                                        _i18n._11171_YESTERDAY | translate
                                    }}</span>
                                </div>
                                <div *ngIf="!cat.isToday && !cat.isYesterday">
                                    <span>{{
                                        cat.lastUpdatedOn
                                            | cmpsDate: 'EEEE, MMM d'
                                    }}</span>
                                </div>
                                <div *ngIf="cat.hasMultipleConversations">
                                    <span class="chat-counter">{{
                                        cat.subCategories.length
                                    }}</span>
                                </div>
                            </div>
                        </div>
                    </cmps-accordion-header>
                    <cmps-accordion-content
                        *ngIf="cat.hasMultipleConversations"
                    >
                        <ng-container
                            *ngFor="let sub of cat.subCategories; let i = index"
                        >
                            <cmps-accordion-item
                                class="sub-category"
                                (click)="_onChatClick(false, sub)"
                            >
                                <cmps-accordion-header>
                                    <span>{{ sub.chat.topic }}</span>
                                </cmps-accordion-header>
                            </cmps-accordion-item>
                        </ng-container>
                    </cmps-accordion-content>
                </cmps-accordion-item>
            </ng-container>
        </cmps-accordion>
    </div>
</div>
